import { toast } from 'sonner';
import { type TFormKeysV4, type TIsDefaultValue } from 'types/questions/question.types.v4';
import { type TFormSubType, type TAvailableLanguageCodes, hasNestedKeys } from '@hubertai/screening-question-types';

export function getFormValue(
  nodeId: string,
  formParams: any,
  questionLanguage: TAvailableLanguageCodes,
  formKey: TFormKeysV4,
  form: TFormSubType,
): TIsDefaultValue {
  try {
    // Check if there's a custom value in formParams
    if (formParams && formKey in formParams && questionLanguage in formParams[formKey]) {
      return {
        isDefault: false,
        value: formParams[formKey][questionLanguage],
      };
    }

    // Otherwise, use default from form
    if (hasNestedKeys(form, formKey, questionLanguage)) {
      return {
        isDefault: true,
        // @ts-ignore
        value: form[formKey][questionLanguage],
      };
    }

    console.log(form, formKey, questionLanguage);
    toast.error(`Question: ${nodeId} and form ${form.id} does not have nested keys ${formKey}, ${questionLanguage}.`);

    return { isDefault: true, value: '' };
  } catch {
    toast.error(`Question: ${nodeId} and form ${form.id} errors. Talk to Jacob.`);
    return { isDefault: true, value: '' };
  }
}
